import { useEffect, useState } from 'react';
import { CabecalhoPagina, Painel } from '../components/ui/index.js';

interface Credito {
  arquivo: string;
  titulo: string;
  autor: string;
  licenca: string;
  licencaUrl: string;
  pagina: string;
}

/**
 * Creditos das fotos de exemplo dos dados ficticios. As licencas CC BY e
 * CC BY-SA pedem o credito do autor; a fonte unica e o creditos.json ao lado
 * das fotos (public/demo/cavalos).
 */
export function CreditosFotos() {
  const [creditos, setCreditos] = useState<Credito[] | null>(null);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    fetch('/demo/cavalos/creditos.json')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((c: Credito[]) => setCreditos(c))
      .catch(() => setErro(true));
  }, []);

  return (
    <div className="space-y-6">
      <CabecalhoPagina
        titulo="Fotos de exemplo"
        meta={
          <span>
            As fotos dos dados fictícios são de Mangalarga Marchador reais, do Wikimedia Commons, com licença livre. Os
            nomes e as medidas dos animais são inventados e não têm relação com os cavalos das fotos.
          </span>
        }
      />
      <Painel titulo="Créditos" corpo="p-0">
        {erro ? (
          <p className="p-4 text-sm text-apagado">Não foi possível carregar os créditos (sem internet?).</p>
        ) : !creditos ? (
          <p className="p-4 text-sm text-apagado">Carregando…</p>
        ) : (
          <ul className="divide-y divide-borda">
            {creditos.map((c) => (
              <li key={c.arquivo} className="flex items-center gap-4 px-4 py-3">
                <img
                  src={`/demo/cavalos/${c.arquivo}`}
                  alt=""
                  loading="lazy"
                  className="h-16 w-24 shrink-0 rounded-[8px] bg-superficie-2 object-cover"
                />
                <div className="min-w-0 text-sm">
                  <a
                    href={c.pagina}
                    target="_blank"
                    rel="noreferrer"
                    className="font-medium text-destaque-texto hover:underline"
                  >
                    {c.titulo}
                  </a>
                  <p className="text-apagado">
                    {c.autor} ·{' '}
                    {c.licencaUrl ? (
                      <a href={c.licencaUrl} target="_blank" rel="noreferrer" className="hover:underline">
                        {c.licenca}
                      </a>
                    ) : (
                      c.licenca
                    )}{' '}
                    · recortada e reduzida
                  </p>
                </div>
              </li>
            ))}
          </ul>
        )}
      </Painel>
    </div>
  );
}
